<template>
  <span v-copy="content" class="copy-icon gj-cell-display-switch">
    <gj-icon v-if="isMeaningful(content)" class="el-icon-copy-document"></gj-icon>
  </span>
</template>

<script>
  import {isMeaningfulMixin} from "../../minxins";

  export default {
    name: "gj-copy-icon",
    mixins: [isMeaningfulMixin],
    props: {
      content: {
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
